import { AnyAction } from "redux"
import {
  PURCHASE_PLAN_CALL,
  PURCHASE_PLAN_FAILURE,
  PURCHASE_PLAN_SUCCESS,
  SET_PURCHASE_PLAN_IDENTIFIERS,
  EVENT_TYPE_OPTIONS_SUCCESS,
  EVENT_TYPE_OPTIONS_FAILURE,
  EVENT_TYPE_OPTIONS_CALL,
  PURCHASE_PLAN_INFO_CALL,
  PURCHASE_PLAN_INFO_SUCCESS,
  PURCHASE_PLAN_INFO_FAILURE,
  PRICING_VARIABLES_RESET
} from "./purchase-plan-actions"

interface EventTypeOptions {
  options: App.SelectOptions[]
  prices: Record<string, string>
}

export interface purchasePlanState {
  identifiers: {
    productPrefixUrl: string
    productId: string
    purchasePlanId: string
  }
  purchasePlanList: {
    data: App.IPurchasePlan[] | App.PurchasePlan[]
    loading: boolean
    error: string
  }
  eventTypeOptions: {
    data: EventTypeOptions
    loading: boolean
    error: string
  }
  purchasePlanInfo: {
    data: App.IPurchasePlanPayload
    loading: boolean
    error: string
  }
}

const INITIAL_STATE: purchasePlanState = {
  identifiers: {
    productPrefixUrl: "",
    productId: "",
    purchasePlanId: ""
  },
  purchasePlanList: {
    data: [],
    loading: false,
    error: ""
  },
  eventTypeOptions: {
    data: { options: [], prices: {} },
    loading: false,
    error: ""
  },
  purchasePlanInfo: {
    data: {
      id: "",
      planKey: "",
      name: "",
      product: {
        id: "",
        name: ""
      },
      description: "",
      benefits: [],
      isEnterprise: false,
      isSimplifiedPricing: true,
      pricingVariables: [],
      fromPrice: "",
      fromPriceUnit: ""
    },
    loading: false,
    error: ""
  }
}

export default function purchasePlanReducer(
  state: purchasePlanState = INITIAL_STATE,
  action: AnyAction
): purchasePlanState {
  switch (action.type) {
    case SET_PURCHASE_PLAN_IDENTIFIERS:
      return {
        ...state,
        identifiers: {
          productPrefixUrl: action.payload.productPrefixUrl,
          productId: action.payload.productId,
          purchasePlanId: action.payload.purchasePlanId
        }
      }

    case PURCHASE_PLAN_CALL:
      return {
        ...state,
        purchasePlanList: {
          ...state.purchasePlanList,
          loading: true
        }
      }

    case PURCHASE_PLAN_SUCCESS:
      return {
        ...state,
        purchasePlanList: {
          data: action.payload as App.IPurchasePlan[] | App.PurchasePlan[],
          loading: false,
          error: ""
        }
      }

    case PURCHASE_PLAN_FAILURE:
      return {
        ...state,
        purchasePlanList: {
          ...state.purchasePlanList,
          loading: false,
          error: action.payload as string
        }
      }

    case EVENT_TYPE_OPTIONS_CALL:
      return {
        ...state,
        eventTypeOptions: {
          ...state.eventTypeOptions,
          loading: true
        }
      }

    case EVENT_TYPE_OPTIONS_SUCCESS:
      return {
        ...state,
        eventTypeOptions: {
          data: action.payload as EventTypeOptions,
          loading: false,
          error: ""
        }
      }

    case EVENT_TYPE_OPTIONS_FAILURE:
      return {
        ...state,
        eventTypeOptions: {
          ...state.eventTypeOptions,
          loading: false,
          error: action.payload as string
        }
      }

    case PURCHASE_PLAN_INFO_CALL:
      return {
        ...state,
        purchasePlanInfo: {
          ...state.purchasePlanInfo,
          loading: true
        }
      }

    case PURCHASE_PLAN_INFO_SUCCESS:
      return {
        ...state,
        purchasePlanInfo: {
          data: action.payload,
          loading: false,
          error: ""
        }
      }

    case PURCHASE_PLAN_INFO_FAILURE:
      return {
        ...state,
        purchasePlanInfo: {
          ...state.purchasePlanInfo,
          loading: false,
          error: action.payload
        }
      }

    case PRICING_VARIABLES_RESET:
      return {
        ...state,
        purchasePlanInfo: {
          ...state.purchasePlanInfo,
          data: {
            ...state.purchasePlanInfo.data,
            pricingVariables: INITIAL_STATE.purchasePlanInfo.data.pricingVariables
          }
        }
      }

    default:
      return state
  }
}
